<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Payroll information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs4 pa-2>
                <v-menu v-model="dateModal" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="theDate"
                    :label="`${$t('Payroll Month')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="Payroll Month"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('Payroll Month')"
                    v-validate="'required|date_format:yyyy-LLLL'"
                  />
                  <v-date-picker @change="dateModal = false" v-model="updateForm.the_month" />
                </v-menu>
              </v-flex>

              <v-flex xs4 pa-2>
                <v-text-field
                  v-model.number="payrollInfo.month_incentive"
                  :label="$t('Incentive')"
                  hide-details
                  box
                  data-vv-name="Incentive"
                  background-color="white"
                  :error="errors.has('Incentive')"
                  v-validate="'decimal:4|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs4 pa-2>
                <v-text-field
                  v-model.number="payrollInfo.month_cut"
                  :label="$t('Cut')"
                  hide-details
                  box
                  data-vv-name="Cut"
                  background-color="white"
                  :error="errors.has('Cut')"
                  v-validate="'decimal:4|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs12 pa-2>
                <v-textarea
                  v-model="payrollInfo.note"
                  :label="$t('Note')"
                  name="note"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      dateModal: false,
      updateForm: {
        the_month: ''
      }
    }
  },

  computed: {
    ...mapGetters({
      payrollInfo: 'payrolls/getPayrollInfo'
    }),

    theDate() {
      if (!this.updateForm.the_month) {
        return ''
      }
      return helpers.formatDateAsMonthYear(this.updateForm.the_month)
    }
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.updateForm.the_month = helpers.reFormatDateFromMonthYear(this.payrollInfo.payroll_month)
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePayrollInfo: 'payrolls/updatePayrollInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('payroll_month', helpers.formatDateAsMonthYear(this.updateForm.the_month))
            formData.append('month_incentive', this.payrollInfo.month_incentive)
            formData.append('month_cut', this.payrollInfo.month_cut)

            if (this.payrollInfo.month_incentive < 1) {
              formData.append('month_incentive', 0)
            }
            if (this.payrollInfo.month_cut < 1) {
              formData.append('month_cut', 0)
            }
            let payload = { id: this.payrollInfo.payroll_id, formData }
            this.updatePayrollInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
